import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

/**
 * Standalone UserManager used purely to read the current access token at API
 * request time. It shares the same authority/client_id/userStore as the
 * AuthProvider, so it reads/writes the exact same localStorage entry
 * (`oidc.user:{authority}:{client_id}`). This lets the axios interceptors pull
 * the freshest token synchronously with the persisted session — decoupled from
 * React's render/effect lifecycle, which previously caused tokens to be missing
 * on requests fired before the interceptor-registering effect had run.
 *
 * It does NOT enable automaticSilentRenew, so it never competes with the
 * AuthProvider's own renew; it only ever reads what that manager persists.
 */
const userManager = new UserManager({
  authority: import.meta.env.VITE_AUTH_AUTHORITY,
  client_id: import.meta.env.VITE_AUTH_CLIENT_ID,
  redirect_uri: window.location.origin + window.location.pathname,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
});

export async function getAccessToken(): Promise<string | undefined> {
  const user = await userManager.getUser();

  return user?.access_token;
}
